import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';

import { OauthClient, useOauthUserRevokeMutation } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';
import { useDeleteOAuthIntegration } from 'updaters';

interface Props {
  integration: OauthClient;
}

const OAuthApps: FC<Props> = ({ integration }) => {
  const notify = useNotify();
  const mutationOptions = useDeleteOAuthIntegration();

  const { t } = useTranslation();

  const { mutate, isLoading } = useOauthUserRevokeMutation({
    onSuccess: () => notify.info({ message: t('components:integrationRevoked') }),
    ...mutationOptions,
  });

  function handleRevoke() {
    mutate({ data: { oauth_client_id: integration.oauth_client_id } });
  }

  return (
    <Grid container justify="space-around" alignItems="center">
      <Grid item xs>
        <Typography variant="subtitle2">{integration.oauth_client_name}</Typography>
      </Grid>
      <Grid item>
        {isLoading ? (
          <Loaders.Standard height={26} />
        ) : (
          <Button size="large" variant="contained" onClick={handleRevoke}>
            {t('common:revoke')}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default OAuthApps;
